var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.69629","y":"0.489258","width":"16","height":"1","transform":"rotate(45 1.69629 0.489258)","fill":"#111111","key":0}),React.createElement("rect",{"x":"0.990234","y":"11.8037","width":"16","height":"1","transform":"rotate(-45 0.990234 11.8037)","fill":"#111111","key":1})]);
}

Close.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = Close;

Close.default = Close;
